import { useSearchHistory } from '@/features/project/_hooks/search-projects/local-storage';
import { PROJECT_BASE_DIR } from '@/features/project/review-sheet/utils/constants';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export const ProjectsPageDynamicLink: FC = () => {
  const { t } = useTranslation();
  const { lastSearchedQueryParams } = useSearchHistory();

  return (
    <Link
      to={{
        pathname: PROJECT_BASE_DIR,
        search: lastSearchedQueryParams.has('fiscalYear')
          ? `?${lastSearchedQueryParams.toString()}`
          : '',
      }}
    >
      {t('projects-page')}
    </Link>
  );
};
